module.exports = __webpack_public_path__ + "img/zw-gift-card.f2153461.svg";